import { safeParseNullDefault, removeNulls } from 'shouldve-been-js';
import MemoTemplateTab from './MemoTemplateTabModel';

class MemoTemplate {

    private _templateId: string;
    private _name: string;
    private _status: string;
    private _tabs: MemoTemplateTab[];

    public constructor(templateId: string, name: string, status: string, tabs: MemoTemplateTab[]) {

        this._templateId = templateId;
        this._name = name;
        this._status = status;
        this._tabs = tabs;
    }

    public get templateId(): string {
        return this._templateId;
    }

    public set templateId(value: string) {
        this._templateId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    public get tabs(): MemoTemplateTab[] {
        return this._tabs;
    }

    public set tabs(value: MemoTemplateTab[]) {
        this._tabs = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): MemoTemplate | null {

        const templateId: string | null = safeParseNullDefault<string>(json?.templateId, '');
        const name: string | null = safeParseNullDefault<string>(json?.name, '');
        const status: string | null = safeParseNullDefault<string>(json?.status, '');
        
        if (templateId === null || name === null || status === null || templateId === '' || name === '' || status === '') {
            return null;
        }

        let tabs: (MemoTemplateTab | null)[] = [];

        if (Array.isArray(json?.tabs)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
            tabs = json.tabs.map((tabObject: any) => {
                return MemoTemplateTab.fromJson(tabObject);
            }); 
        }

        return new MemoTemplate(templateId, name, status, removeNulls(tabs));
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): MemoTemplate | null {

        const templateId: string | null = safeParseNullDefault<string>(object?._templateId, '');
        const name: string | null = safeParseNullDefault<string>(object?._name, '');
        const status: string | null = safeParseNullDefault<string>(object?._status, '');
        
        if (templateId === null || name === null || status === null || templateId === '' || status === '') {
            return null;
        }

        if (!Array.isArray(object?._tabs)) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
        const tabs: (MemoTemplateTab | null)[] = object._tabs.map((tabObject: any) => {
            return MemoTemplateTab.fromIndexedDB(tabObject);
        });  

        return new MemoTemplate(templateId, name, status, removeNulls(tabs));
    }
}

export default MemoTemplate;